module.exports = __webpack_public_path__ + "stylesheets/icon-text-list_f860b2e82ef7ac88f4c121666f854125.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/icon-text-list.less
// module id = 5G1g
// module chunks = 153